module.exports = __webpack_public_path__ + "static/media/insta.2b3dfcdf.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/insta.svg
// module id = 237
// module chunks = 0